import Modifier from 'ember-modifier';
import { registerDestructor } from '@ember/destroyable';
import { inject as service } from '@ember/service';

function cleanup(instance) {
  instance.element.removeEventListener('click', instance.onClick);
}

export default class TrackEvent extends Modifier {
  @service metrics;

  constructor(owner, args) {
    super(owner, args);
    registerDestructor(this, cleanup);
  }

  modify(element, positional, { name, on = 'click' }) {
    if (!this.element) {
      this.element = element;
      this.element.addEventListener(on, this.trackEvent.bind(this));
    }
    this.name = name;
  }

  trackEvent() {
    this.metrics.trackEvent({
      name: this.name,
    });
  }
}
